import React from 'react';
import '../style.scss';
import { PagePath } from 'constants/pagePath';
import { Button, ButtonFill, ButtonSize, ButtonType } from 'views/mutual/button';
import { useLogin } from './hooks';
import { NavLink, useNavigate } from 'react-router-dom';
import { IconSize, SvgIcon } from 'views/mutual/svgIcon';
import { IconName, findIcon } from 'utils/handleIcon';

export const Login = () => {
  const navigte = useNavigate();
  const { isRevealPassword, togglePassword, formik, toastProps } = useLogin();
  const icon = findIcon(isRevealPassword ? IconName.eyeOn : IconName.eyeOff);

  return (
    <>
      <form onSubmit={formik.handleSubmit} className="loginsStyle">
        <div className="loginsStyle_inputs">
          <div className="loginsStyle_inputs_wrapper">
            <div className="loginsStyle_inputs_wrapper_label">口座番号</div>
            <div className="loginsStyle_inputs_wrapper_button">
              <input type="text" name="account" value={formik.values.account} onChange={formik.handleChange} />
            </div>
            {formik.errors.account ? <div className="errorRed">{formik.errors.account}</div> : null}
          </div>

          <div className="loginsStyle_inputs_wrapper">
            <div className="loginsStyle_inputs_wrapper_label">
              <span>パスワード</span>
              <NavLink to={PagePath.ReissuePassword}>パスワードをお忘れの方はこちら</NavLink>
            </div>
            <div className="loginsStyle_inputs_wrapper_button">
              <input
                type={isRevealPassword ? 'text' : 'password'}
                name="password"
                value={formik.values.password}
                onChange={formik.handleChange}
              />
              <span onClick={togglePassword}>
                <SvgIcon icon={icon} size={IconSize.icon_s} />
              </span>
            </div>
            {formik.errors.password ? <div className="errorRed">{formik.errors.password}</div> : null}
          </div>

          <div className="loginsStyle_inputs_buttons">
            <Button
              type={ButtonType.Submit}
              label="ログイン"
              buttonFill={ButtonFill.primary}
              buttonSize={ButtonSize.medium}
            />
            <span>or</span>
            <div className='loginsStyle_inputs_buttons_openAccount'>
              <Button
                label="法人口座開設"
                buttonFill={ButtonFill.primary}
                buttonSize={ButtonSize.medium}
                onClick={() => navigte(PagePath.AccountOpen)}
              />
              <Button
                label="個人口座開設"
                buttonFill={ButtonFill.primary}
                buttonSize={ButtonSize.medium}
                onClick={() => navigte(PagePath.PersonalAccountOpen)}
              />
            </div>            
          </div>
        </div>
      </form>
    </>
  );
};
